import { render, staticRenderFns } from "./FlyTable.vue?vue&type=template&id=1b0a38f2"
import script from "./FlyTable.vue?vue&type=script&lang=js"
export * from "./FlyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports